import './valley.scss';
import {ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {Loader, Placeholder} from 'rsuite';
import Lottie from "lottie-react";
import dietLoading from '../../animations/diet_loading.json';

const Valley = (props) => {
    const {message} = props;

    return (
        <>
            <div className="container valley">
                <div className="form-container">
                    <div className="center">
                        <Placeholder.Paragraph rows={8}/>
                        <Lottie animationData={dietLoading} loop={true} />
                        <div>
                            درحال بارگذاری ...
                        </div>
                    </div>
                </div>

                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </div>
        </>
    );
}

export default Valley;